<template>
  <el-card>
    <div v-wechat-title="title" />

    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="left">
      <el-col :span="20">
        <div style="margin: 8px;" />
      </el-col>
      <el-col v-if="hasPermOrderBuyOffline" :span="4">
        <span class="text item">
          <el-popconfirm title="确认商品清单入库吗？" @confirm="onSubmitOrder()">
            <el-button type="primary" slot="reference">确认入库</el-button>
          </el-popconfirm>
        </span>
      </el-col>
    </el-row>

    <el-divider content-position="left">入库信息</el-divider>
    <el-row type="flex" justify="left">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        style="width:1100px;"
        :submit-text="'确认入库'"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
        :info-mode="true"
        :disable-stay="true"
      >
        <el-form-item label="商品清单" prop="items">
          <el-col>
            <el-button size="mini" type="primary" @click="addGoods" plain>添加商品</el-button>
          </el-col>
          <el-col>
            <el-card>
              <el-table :data="form.items" style="width: 100%" height="320">
                <el-table-column prop="name" label="商品名称">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.goods_id" filterable placeholder="请选择商品">
                      <el-option v-for="item in goodsList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column prop="price" label="价格" width="80" />
                <el-table-column prop="nums" label="入库数量" width="155">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.nums" size="small" :min="1" :max="99999" />
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="小计" width="110" />
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-popconfirm
                      confirm-button-text="好的"
                      cancel-button-text="不用了"
                      icon="el-icon-info"
                      icon-color="red"
                      title="确定要删除商品吗？"
                      @confirm="onDestroyConfirm(scope.row)"
                    >
                      <el-button type="danger" size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-form-item>

        <el-form-item label="仓库信息" prop="warehouse_code">
          <el-select v-model="form.warehouse_code" clearable filterable placeholder="请选择所属仓库">
            <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.code">
              <span style="float: left">{{ item.name }}<space v-if="item.is_default == 1" style="color:coral">[默认]</space></span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.city + '/' + item.address }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="其他信息" prop="memo">
          <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" placeholder="入库说明" v-model="form.memo" />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { createInStorage, storeInStorage, updateInStorage } from '@/api/in-storages'
import { can } from '@/libs/utils'

import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import Space from '../../components/Space.vue'

export default {
  name: 'Form',
  components: {
    LzForm,
    Space,
  },
  mixins: [FormHelper],
  data() {
    return {
      title: '编辑入库',
      form: {
        id: 0,
        item_num: 0,
        warehouse_code: '',
        memo: '',
        items: [],
      },

      errors: {},
      hasPermOrderBuyOffline: false,
      defaultWarehouse: '',
      goodsList: [],
      warehouseList: [],
    }
  },
  computed: {},
  created() {
    this.hasPermOrderBuyOffline = can('order.warehouses.create')
  },
  methods: {
    async getData() {
      const { data } = await createInStorage()
      const { goods, warehouses } = data
      this.goodsList = goods
      this.warehouseList = warehouses
      if (warehouses.length > 0) {
        this.defaultWarehouse = warehouses[0]['code']
        this.form.warehouse_code = this.defaultWarehouse
      }
    },

    async onSubmit() {
      if (this.editMode) {
        await updateInStorage(this.resourceId, this.form)
      } else {
        await storeInStorage(this.form)
      }
    },

    async onSubmitOrder() {
      if (this.form.items.length==0) {
        this.$message({
          message: '商品清单中存在有空项，请补充完善。',
          type: 'warning',
        })
        return
      }
      if (await this.componentGoodsList()) {
        this.$message({
          message: '商品清单中存在有空项，请补充完善。',
          type: 'warning',
        })
        return
      }

      const res = await storeInStorage(this.form)
      console.log(res)
      if (res.status === 201) {
        this.$message.success('入库成功.')
        this.resetForm()
        this.form.warehouse_code = this.defaultWarehouse
      }
    },

    async addGoods() {
      this.form.items.push({
        goods_id: '',
        name: '',
        price: 0,
        nums: 1,
        amount: 0,
      })
    },

    async filterGood(goods_id) {
      const goods = this.goodsList.filter(item => {
        return item.id === goods_id
      })

      return goods[0] || {}
    },

    async componentGoodsList() {
      let isEmptyIn = false

      this.form.items.forEach(async item => {
        console.log('item:', item)
        if (item.goods_id == 0 || item.goods_id == '') {
          isEmptyIn = true
          return
        }

        const goods = await this.filterGood(item.goods_id)
        if (goods && goods.id) {
          item.name = goods.name
          item.price = goods.price
          const nums = item.nums
          item.amount = Number(item.price * nums).toFixed(1)
        }
      })
      console.log('isEmptyIn', isEmptyIn)
      return isEmptyIn
    },

    async onDestroyConfirm(item) {
      const index = this.form.items.indexOf(item)
      if (index !== -1) {
        this.form.items.splice(index, 1)
      }
    },

    resetForm() {
      this.form = {
        id: 0,
        title: '',
        item_num: 0,
        total_amount: 0.0,
        final_amount: 0.0,
        memo: '',
        pick_up_order: '',
        items: [],
      }
    },
  },
  watch: {
    'form.items': {
      handler(newGoods) {
        console.log(newGoods)
        let amount = 0.0
        newGoods.forEach(async item => {
          const goods = await this.filterGood(item.goods_id)
          if (goods && goods.id) {
            item.name = goods.name
            item.price = goods.price
            const nums = item.nums
            item.amount = Number(item.price * nums).toFixed(1)
          }

          amount += Number(item.amount)
          console.log(item, goods, amount)

          this.form.total_amount = this.form.final_amount = Number(amount).toFixed(1)
        })
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss"></style>
